import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryLocations = createRoutine(
  'FETCH_INVENTORY_LOCATIONS'
);

export const fetchInventoryLocation = createRoutine('FETCH_INVENTORY_LOCATION');

export const createInventoryLocation = createRoutine(
  'CREATE_INVENTORY_LOCATION'
);
export const updateInventoryLocation = createRoutine(
  'UPDATE_INVENTORY_LOCATION'
);
export const deleteInventoryLocation = createRoutine(
  'DELETE_INVENTORY_LOCATION'
);
